import React, { useEffect, useState } from "react";
import { authFetch, API_BASE } from "../utils/auth";

interface SecureImageProps {
  filename: string;
}

const SecureImage: React.FC<SecureImageProps> = ({ filename }) => {
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  useEffect(() => {
    // Track the object URL in effect scope so the effect's OWN cleanup can revoke
    // it. A cleanup returned from the inner async function is a promise, which
    // React ignores -- that was leaking a blob URL on every remount/filename change.
    let objectUrl: string | null = null;
    let cancelled = false;

    const fetchImage = async () => {
      try {
        const res = await authFetch(`${API_BASE}/uploads/${filename}`, {
          method: "GET",
        });

        if (!res.ok) throw new Error("Image fetch failed");

        const blob = await res.blob();
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setImageUrl(objectUrl);
      } catch (err) {
        console.error("Failed to load image", err);
      }
    };

    fetchImage();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [filename]);

  if (!imageUrl) return <p>Loading image...</p>;

  return (
    <img
      src={imageUrl}
      alt="Secure content"
      className="h-40 rounded shadow"
    />
  );
};

export default SecureImage;
